export const defaultState = {
  data: {
    file: null,
  },
  errors: {},
};

const UPDATE_FIELD = 'UPDATE_FIELD';
const SET_ERRORS = 'SET_ERRORS';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });
export const setErrorsCreator = (payload) => ({ type: SET_ERRORS, payload });

export default function (state = defaultState, action) {
  if (action.type === UPDATE_FIELD) {
    return { ...state, data: { ...state.data, [action.payload.name]: action.payload.value } };
  }

  if (action.type === SET_ERRORS) {
    return { ...state, errors: action.payload };
  }

  return state;
}
